import { Spinner } from '../SpinnerComponent';

type TProps = {
  overlay?: boolean;
  className?: string;
};

export const AbsoluteSpinner = ({ overlay, className }: TProps) => (
  <Spinner overlay={overlay} className={['absolute left-0 top-0', className].filter(Boolean).join(' ')} />
);
